let stripe = {
  redirectToCheckout: () => {},
};

if (process.env.NODE_ENV !== "development") {
  stripe = new global.Stripe(process.env.REACT_APP_STRIPE);
}

export default stripe;
